import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { matchesSearch } from '@/lib/text';
import type { NavItem } from './navigation';

/**
 * Busca do cabeçalho (§19), aberta também por Ctrl/⌘ K. Por ora leva às telas; quando produtos
 * e pedidos tiverem busca no servidor, entram aqui como outros grupos.
 */
export function CommandSearch({ items }: { items: NavItem[] }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key.toLowerCase() === 'k' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        setOpen((value) => !value);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  function go(to: string) {
    setOpen(false);
    void navigate(to);
  }

  return (
    <>
      {/* No celular só o ícone: o cabeçalho não comporta o campo inteiro. */}
      <Button
        variant="outline"
        aria-label="Buscar"
        className="size-9 px-0 text-muted-foreground sm:w-64 sm:justify-start sm:px-3"
        onClick={() => setOpen(true)}
      >
        <Search aria-hidden />
        <span className="hidden flex-1 text-left sm:inline">Buscar…</span>
        <kbd className="hidden rounded border bg-muted px-1.5 text-xs sm:inline">Ctrl K</kbd>
      </Button>
      <CommandDialog
        open={open}
        onOpenChange={setOpen}
        title="Buscar"
        description="Vá para uma tela do troig."
        // Sem acento e sem caixa: "configuracoes" acha "Configurações".
        filter={(value, search) => (matchesSearch(value, search) ? 1 : 0)}
      >
        <CommandInput placeholder="Para onde você quer ir?" />
        <CommandList>
          <CommandEmpty>Nenhuma tela com esse nome.</CommandEmpty>
          {items.map((item) =>
            item.kind === 'link' ? (
              <CommandItem key={item.to} value={item.label} onSelect={() => go(item.to)}>
                <item.icon aria-hidden />
                {item.label}
              </CommandItem>
            ) : item.kind === 'group' ? (
              <CommandGroup key={item.label} heading={item.label}>
                {item.children.map((child) => (
                  <CommandItem
                    key={child.to}
                    value={`${item.label} ${child.label}`}
                    onSelect={() => go(child.to)}
                  >
                    {child.label}
                  </CommandItem>
                ))}
              </CommandGroup>
            ) : null,
          )}
        </CommandList>
      </CommandDialog>
    </>
  );
}
